<template>
  <v-container class="iframe-body modal_content">
    <div style="max-width: 898px;">
      <div class="Step-4">{{ $t('sign.title') }}</div>
      <alert v-if="snackbar" :errorMsg="errorMsg" />

      <div class="textSign">
        <p>{{ $t('sign.text1') }}</p>
        <p>{{ $t('sign.text2') }}</p>
      </div>
    </div>
  </v-container>
</template>

<script>
import { START_TSP } from '@/stores/consts';

export default {
  name: 'Sign',
  computed: {
    snackbar: {
      get() {
        return this.$store.state.snackbar;
      },
      set(newValue) {
        return this.$store.commit('snackbar', newValue);
      },
    },
    errorMsg: {
      get() {
        return this.$store.state.errorMsg;
      },
      set(newValue) {
        return this.$store.commit('errorMsg', newValue);
      },
    },
  },
  created() {
    this.TSP_URL = window.TSP_URL;
    this.session_id_tsp = window.session_id_tsp;
  },
  methods: {
    signDocument: async function() {
      var FORCE_URL = 'https://tsp.api.wallid.io/api/tsp';

      var url;

      if (typeof this.TSP_URL != 'undefined' && this.TSP_URL) {
        url = this.TSP_URL + '/startTSP';
      } else {
        url = FORCE_URL + '/startTSP';
      }

      // force prod url
      url = FORCE_URL + '/startTSP';

      this.$store
        .dispatch(START_TSP, { url })
        .then((response) => {
          console.log('Data Response on error ', response);
          return this.handleErrors(response);
        })
        .then((response) => {
          console.log('Data Response sucess ', response);
          return this.handleSucess(response);
        })
        .catch((error) => {
          this.$store.commit('signing', false);

          if (error.response && error.response.status == 555) {
            console.log(error.response);
            window.location.replace(error.response.data.data.redirectUrl);
          } else {
            this.errorMsg = 'token';
            this.snackbar = true;
            this.$eventHub.$emit('eventUpdate', {
              time: 1,
              params: {
                msg: this.$i18n.t('intercom.failSign'),
              },
            });
            this.$store.commit('loading', false);
          }
        });
    },
    handleErrors(response) {
      if (response.status > 300) {
        console.log('response = ', response);
        console.log('response.status = ', response.status);
        this.errorMsg = 'token';
        this.snackbar = true;
        this.$eventHub.$emit('eventUpdate', {
          time: 1,
          params: {
            msg: this.$i18n.t('intercom.failSign'),
          },
        });
        this.$store.commit('signing', false);
        throw Error(response.status);
      }
      return response;
    },
    //merge handle sucess with handle error
    handleSucess(response) {
      var res = response.data;
      console.log('Data sent to TSP response : ', res);
      console.log('Document signed');
      if (res.data.redirectionURL) {
        var redirectUrl = res.data.redirectionURL;
        this.$store.commit('redirectUrl', redirectUrl);
      }
      if (res.data.envelopeID) {
        var envelopeID = res.data.envelopeID;
        this.$store.commit('envelopeID', envelopeID);
      }
      if (res.data.documents) {
        var documents = res.data.documents;
        this.$store.commit('documents', documents);
      }

      this.$store.commit('step', 3);
      this.$store.commit('signing', false);

      this.$router.push('success');

      return res;
    },
  },
  data() {
    return {
      TSP_URL: null,
      session_id_tsp: '',
    };
  },
};
</script>

<style scoped>
.vuebar-element {
  height: 234px;
  width: 100%;
}

.back {
  margin-right: 11px;
  margin-left: 0px;
  width: 109px;
  height: 36px;
  border-radius: 2px;
  border: solid 1px #035b60;

  font-family: 'Montserrat';
  font-size: 15px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.6;
  letter-spacing: normal;
  text-align: center;
  color: #035b60;
}
.sign {
  margin-right: 0px;
  margin-left: 0px;
  padding: 0;
  width: 165px;
  font-family: 'Montserrat';
  font-size: 15px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.6;
  letter-spacing: normal;
  text-align: center;
  color: #c6eaed;
}

.Step-4 {
  padding-top: 0px;
  margin-top: 0px;
  margin-bottom: 24px;
  width: 608px;
  height: 24px;
  font-family: 'Montserrat';
  font-size: 20px;
  font-weight: 600;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.2;
  letter-spacing: normal;
  color: #035b60;
  text-align: left;
}
</style>
